import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "",
    name: "Home",
    component: () =>
      import("../views/Home.vue")
  },
  {
    path: "/restaurantparameter",
    name: "restaurantparameter",
    component: () =>
      import("../views/Kostenstruktur.vue")
  },
  {
    path: "/umsatzplanung",
    name: "umsatzplanung",
    component: () =>
      import("../views/SalesPlanning.vue")
  },
  {
    path: "/personaleinsatz",
    name: "personaleinsatz",
    component: () =>
      import("../views/Personaleinsatz.vue")
  },
  {
    path: "/ergebnis",
    name: "ergebnis",
    component: () =>
      import("../views/Ergebnis.vue")
  },
  {
    path: "/impressum",
    name: "impressum",
    component: () =>
      import("../views/Impressum.vue")
  },
  {
    path: "/datenschutzerklaerung",
    name: "datenschutzerklaerung",
    component: () =>
      import("../views/Datenschutzerklaerung.vue")
  }
];

const router = new VueRouter({
  routes
});

export default router;
